import { connect } from 'react-redux'
import TableView from '../../../../common/containers/TableView'
import { useEffect } from 'react'
import { bindActionCreators } from 'redux'
import { callLocationCategoryListGet, callLocationCategoryDelete } from '../../actions/locationCategories' 
import { Link, useSearchParams } from 'react-router-dom'
import Swal from 'sweetalert2'

let LocationCategoryList = ({ setPageAttr, list, methods: { callLocationCategoryListGet, callLocationCategoryDelete } }) => {
    let [searchParams] = useSearchParams();
    const remove = (id) => {
        Swal.fire({
            title: 'Tem certeza que deseja deletar? Essa ação não poderá ser desfeita!',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Sim',
            denyButtonText: `Não`,
        }).then((result) => {
            if (result.isConfirmed) {
                callLocationCategoryDelete(id, () => {
                    let pg = searchParams.get('pg')
                    pg = pg ? pg : 1
                    callLocationCategoryListGet({}, pg)
                })
            }
        })
    }
    const headers = [
        {
            type: 'info',
            name: 'name',
            align: 'left',
            label: 'Nome'
        },
        {
            type: 'datetime',
            name: 'createdAt',
            align: 'left',
            label: 'Cadastro'
        },
        {
            type: 'custom',
            align: 'right',
            label: 'Opções',
            custom: (a) => {
                return (
                    <>
                        <Link to={'/location-categories/edit/' + a.id} className='btn btn-sm btn-primary'><i className='fas fa-edit'></i></Link>
                        <span className='btn btn-sm btn-danger ml-2' onClick={() => remove(a.id)}><i className='fas fa-trash'></i></span>
                    </>
                )
            }
        }
    ]

    useEffect(() => {
        let pg = searchParams.get('pg')
        pg = pg ? pg : 1
        callLocationCategoryListGet({}, pg)
    }, [callLocationCategoryListGet, searchParams])

    useEffect(() => {
        setPageAttr({
            title: 'Tipo de Locais',
            caption: 'Configuração dos tipos de locais',
            btns: [
                {
                    type: 'link',
                    class: 'btn btn-primary',
                    icon: 'fas fa-plus',
                    label: 'Adicionar',
                    to: '/location-categories/add'
                }
            ],
            tabs: [
                {
                    active: true,
                    to: '/location-categories',
                    label: 'Informações'
                }
            ]
        })
    }, [setPageAttr])

    return (
        <TableView headers={headers} rows={list.rows} total={list.total} pagination={list.pagination} paginationTo={'/location-categories'} />
    )
}

const mapStateToProps = ({ config: { locationCategories: { list } } }) => ({
    list: list,
});

const mapDispatchToProps = (dispatch) => ({
    methods: bindActionCreators(
        {
            callLocationCategoryListGet,
            callLocationCategoryDelete
        },
        dispatch
    )
});

export default connect(mapStateToProps, mapDispatchToProps)(LocationCategoryList)